import { Component, OnInit, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';

@Component({
	selector: 'modal-image',
	templateUrl: './image-modal.component.html',
	styleUrls: ['./image-modal.component.css'],
})
export class ImageModalComponent implements OnInit {
    @Input() title: String;
    @Input() ruta_image: String;
    constructor(
        public bsModalRef: BsModalRef,
    ){
        //
    }

    ngOnInit(){
        //
    }
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/image-modal/image-modal.component.ts